import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../metapixel";

function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    // SPA route change => manual PageView
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

export default MetaPixelTracker;
